export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/06b133b24ebd78b5b73a3aeb462f8387.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <p className="text-gray-300 text-sm font-light tracking-wider uppercase mb-6">iOS Development Experts</p>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-8">
          Crafting Premium<br />
          iOS Applications<br />
          For Modern Users
        </h1>
        
        <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-16">
          A team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6">
          <div className="flex items-center gap-3 bg-gray-800/60 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-shield-check-line text-teal-400 text-xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white text-sm font-medium whitespace-nowrap">Advanced Security</span>
          </div>
          
          <div className="flex items-center gap-3 bg-gray-800/60 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-speed-line text-teal-400 text-xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white text-sm font-medium whitespace-nowrap">High Performance</span>
          </div>
          
          <div className="flex items-center gap-3 bg-gray-800/60 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-lightbulb-line text-teal-400 text-xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white text-sm font-medium whitespace-nowrap">Innovation First</span>
          </div>
          
          <div className="flex items-center gap-3 bg-gray-800/60 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-star-line text-teal-400 text-xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white text-sm font-medium whitespace-nowrap">Premium Quality</span>
          </div>
          
          <div className="flex items-center gap-3 bg-gray-800/60 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-customer-service-2-line text-teal-400 text-xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white text-sm font-medium whitespace-nowrap">Expert Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}